module.exports = __webpack_public_path__ + "5708b2fab0b87ecb7a844f2730a9ee3f.jpg";